export const categories = [
    {
        id: 1,
        name: "Necklace"
    },
    {
        id: 2,
        name: "Bracelet"
    },
    {
        id: 3,
        name: "Ring"
    },
    {
        id: 4,
        name: "Earring"
    },  
    {
        id: 5,
        name: "Pendant"
    },
    {
        id: 6,
        name: "Chain"
    },
    {
        id: 7,
        name: "Bangle"
    },
    {
        id: 8,
        name: "Other"
    }
]

export const purityOptions = [
    {
        id: 1,
        name: 18
    },
    {
        id: 2,
        name: 22
    },
    {
        id: 3,
        name: 24
    },
    {
        id: 4,
        name: 916
    },
    {
        id: 5,
        name: 925
    },
]